import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { GlobalProvider } from '../../providers/global/global';

/*
  Generated class for the RequestsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RequestsProvider {
  
  GridDataReceived = new Subject<void>();
  ExpensesDataReceived = new Subject<void>();
  ExpensesPopupDataReceived = new Subject<void>();
  TotalsReceived = new Subject<void>();
  TimesheetAutofillReceived = new Subject<void>();
  MonthlyTotalsReceived = new Subject<void>();
  Grid1Data: any;
  Grid2Data: any;

  constructor(public http: HttpClient,public global: GlobalProvider) {
    console.log('Hello RequestsProvider Provider');
  }

  httpRequest_totalgrid1(){

    this.global.createLoader();
    this.global.loading.present().then((result) => {

    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    p.id = 'TOTALS2';
    p.entity = 'TOTALS2GRID1';

    const params = new HttpParams().set('j',JSON.stringify(p))

    this.http.post('timesheets/timesheet_read/',params).subscribe(

      (data) => {

          var res1: any = data;
          if (res1.result == true) {

            this.global.dt_grid1 = JSON.parse(res1.dt);

            //this.global.grid1Visibility=true;

            this.global.grid1Visibility = true;
            this.httpRequest_totalgrid2();

          }
          else {
            this.global.grid1Visibility = false;
            this.httpRequest_totalgrid2();
          }

      },
      error => {
        alert('error');
      }
    );

  }).catch((err) => {

  });


  }

  httpRequest_totalgrid2(){

    //debugger;
    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    //p.id = this.tab2id;
    //p.id = this.global.TAB2id[this.global.ndaysIndex-1];
    p.id = 'TOTALS2';
    p.entity = 'TOTALS2GRID2';


    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/',params).subscribe(

      (data) => {

        //debugger;
        var res2: any = data;

        if(res2.result==true)
        {
          //console.log('2: ' + this.res2);
          this.global.dt_grid2 = JSON.parse(res2.dt);
          //console.log(this.global.dt_grid2);
          this.global.grid2Visibility = true;
          this.httpRequest_totalexpenses();
          
        }
        else {

          this.global.grid2Visibility = false;
          this.httpRequest_totalexpenses();


        }
      },
      error => {
        alert('error');
      }
    );

  }
  
 httpRequest_totalexpenses(){
  // this.global.createLoader();
  // this.global.loading.present().then((result) => {

    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.contacttype = this.global.contacttype;
    p.timesheetentriesid = '0';
    p.userid = '0';

    const params = new HttpParams().set('j',JSON.stringify(p))


    this.http.post('timesheets/expenses_read/',params).subscribe(

      (data) => {

        this.global.loading.dismiss();
        var resexpenses: any = data;
        if (resexpenses.result == true) {
          
          // var dt_expenses_total = JSON.parse(resexpenses.dt);
          this.global.dt_expenses = JSON.parse(resexpenses.dt);
          this.global.dt_expenses_total_confirm = JSON.parse(this.global.dt_expenses[0]);
          // debugger
          // console.log(JSON.parse(this.global.dt_expenses[1]))

          //IN CASE THERE ARE NO EXPENSES ENTERED, THIS ROW IS EMPTY
          //THEREFORE THE EXPENSES DONT APPEAR IN TOTALS PAGE
          //THAT'S WHY WE ADD THIS ROW
          if (this.global.dt_expenses_total_confirm.length == 0 ){
            this.global.dt_expenses_total_confirm.push({
                'Miles':0,
                'MilesAmount' : 0,
                'TotalExpenses': 0,
                'GrandTotal': 0,
                'MilageRate' : JSON.parse(this.global.dt_expenses[1])[0].Mileage })
          }

          for (var key in this.global.dt_expenses_total_confirm[0]) {
            var v = this.global.dt_expenses_total_confirm[0][key];
            //v = v.toFixed(2);
            if (key=="MilageRate") v= v.toFixed(4);
            else v = v.toFixed(2);
            this.global.dt_expenses_total_confirm[0][key] = v;
          }
      
          //BECAUSE THIS ALWAYS RETURNS DATA
          //DECIDE IF THERE IS EXPENSES FROM TAB2ID
          for(var x = 0; x < this.global.TAB2id.length; x++){
            if (this.global.TAB2id[x].trim() == "EXPENSES2"){
              
              this.global.expensesVisibility = true;
              break;

            } else {
              
              this.global.expensesVisibility = false;

            }
          }
          if(this.global.TimesheetPeriod == 1){this.MonthlyTotalsReceived.next();}
          else{this.TotalsReceived.next();}
          
          
        } else {

          this.global.expensesVisibility = false;
          if(this.global.TimesheetPeriod == 1){this.MonthlyTotalsReceived.next();}
          else{this.TotalsReceived.next();}
        }
        
      },
      error => {
        alert('error');
      }
    );

  // }).catch((err) => {

  // });
 }
 httpRequest_totalmonthly(){

  this.global.createLoader();
  this.global.loading.present().then((result) => {

  var p:any={};
  //p.sp_name = "sp_timesheet1_totals";
  p.timesheetid = this.global.timesheetid;

  const params = new HttpParams()
  .set('j',JSON.stringify(p))

  this.http.post('timesheets/timesheet_read_monthly_totals/',params).subscribe(

    (data) => {

      //debugger;
      

        var res1: any = data;
        if (res1.result == true) {

          this.global.dt_grid1 = JSON.parse(res1.dt);
          //this.navCtrl.push(ConfirmType1MonthlyPage);
          this.httpRequest_totalexpenses();
          this.global.grid1Visibility=true;

          //this.global.grid1Visibility = true;
          //this.httpRequest_totalgrid2();

        }
        else {
          this.global.dt_grid1 = [];
          this.httpRequest_totalexpenses();
          this.global.grid1Visibility = false;
          //this.httpRequest_totalgrid2();
        }

    },
    error => {
      alert('error');
    }
  );

}).catch((err) => {

});


}
//  httpRequest_totalexpenses(){

//     //debugger;
//     var p:any={};
//     p.timesheetid = this.global.timesheetid;
//     p.timesheettype = this.global.timesheettype;
//     p.contacttype = this.global.contacttype;
//     p.agencyid = this.global.agencyid;
//     //p.id = this.tab2id;
//     //p.id = this.global.TAB2id[this.global.ndaysIndex-1];
//     p.id = 'TOTALS2';
//     p.entity = 'TOTALS2GRID3';  //expenses


//     const params = new HttpParams()
//     .set('j',JSON.stringify(p))


//     this.http.post('timesheets/timesheet_read/',params).subscribe(

//       (data) => {

//         //debugger;
//         var res2: any = data;

//         if(res2.result==true)
//         {
//             // debugger
//             this.global.dt_expenses_total = JSON.parse(res2.dt);
//             this.global.expensesVisibility = true;  
//             this.TotalsReceived.next();
//         }
//         else {
//           this.global.expensesVisibility = false;
//           this.TotalsReceived.next();
//         }
//       },
//       error => {
//         alert('error');
//       }
//     );

//   }

  httpRequestGrid1_read(id: string){
    //debugger
    this.global.createLoader();
    this.global.loading.present().then((result) => {

    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    p.id = id;
    p.entity = 'GRID1';


    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/',params).subscribe(

      (data) => {
        this.Grid1Data = data;
        if (this.Grid1Data.result == true) {

          this.global.dt_grid1 = JSON.parse(this.Grid1Data.dt);
          this.global.grid1Visibility = true;
          this.httpRequestGrid2_read(id);

        }
        else {
          this.global.grid1Visibility=false;
          this.httpRequestGrid2_read(id);
        }
        
      },
      error => {
        alert('error');
      }
    );

  }).catch((err) => {

  });


  }

  httpRequestGrid2_read(id: string){

    var p:any = {};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    p.id = id;
    p.entity = 'GRID2';

    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/',params).subscribe(

      (data) => {
        
        this.global.loading.dismiss();
        this.Grid2Data = data;        
        if(this.Grid2Data.result == true)
        {

          this.global.dt_grid2 = JSON.parse(this.Grid2Data.dt);
          this.global.grid2Visibility = true;
          this.GridDataReceived.next();

        }
        else {
          this.global.grid2Visibility = false;
          this.GridDataReceived.next();
        }


      },
      error => {
        alert('error');
      }
    );
  }

  httpRequestExpenses_read(){
    
    //j: {"sp_name":"sp_expenses_read","UserId":0,"TimesheetId":"5208","TimesheetEntriesID":"0"}
    this.global.createLoader();
    this.global.loading.present().then((result) => {

      var p:any={};
      p.timesheetid = this.global.timesheetid;
      p.contacttype = this.global.contacttype;
      p.timesheetentriesid = '0';
      p.userid = '0';

      const params = new HttpParams()
      .set('j',JSON.stringify(p))


      this.http.post('timesheets/expenses_read/',params).subscribe(

        (data) => {
          //debugger

          this.global.loading.dismiss();
          var resexpenses: any = data;
          if (resexpenses.result == true) {
            this.global.dt_expenses = JSON.parse(resexpenses.dt);
            this.ExpensesDataReceived.next();
            this.ExpensesPopupDataReceived.next();
            this.httpRequestExpenses_ddl_read();
            
          }
          
        },
        error => {
          alert('error');
        }
      );

    }).catch((err) => {

    });


  }

  httpRequestExpenses_ddl_read(){
    //this.global.createLoader();
    //this.global.loading.present().then((result) => {

    var p:any = {};
    //p.sp_name = "sp_expense_types_ddl";
    p.timesheetid = this.global.timesheetid;
    p.timesheetentriesid = '0';

    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/expenses_ddl_read/',params).subscribe(

      (data) => {
        //debugger

        //this.global.loading.dismiss();
        var resexpenses_ddl : any = data;
        if (resexpenses_ddl.result == true) {
          //debugger
          this.global.dt_expenses_ddl = JSON.parse(resexpenses_ddl.dt);
          //this.navCtrl.push(ExpensesPage);
        }
        
      },
      error => {
        alert('error');
      }
    );



  }

  httpRequestGrid_Footer(){
    this.global.createLoader();
    this.global.loading.present().then((result) => {

      var p:any={};
      p.timesheetid = this.global.timesheetid;
      p.timesheettype = this.global.timesheettype;
      p.contacttype = this.global.contacttype;
      p.entity = 'TOTALS2FOOTER';


      const params = new HttpParams()
      .set('j',JSON.stringify(p))


      this.http.post('timesheets/timesheet_read/',params).subscribe(

        (data) => {
          
          
        },
        error => {
          alert('error');
        }
      );

    }).catch((err) => {

    });
  }


  httpRequestAutoFill(Id_Tab2: string){
    this.global.createLoader();
    this.global.loading.present().then((result) => {
      
      var p:any={};
      p.timesheetid = this.global.timesheetid;
      p.contacttype = this.global.contacttype;
      p.date = Id_Tab2;
      p.forwardonly = "1";

      const params = new HttpParams().set('j',JSON.stringify(p))

      this.http.post('timesheets/timesheet_autofill/',params).subscribe(

        (data) => {

          this.global.loading.dismiss();    
          this.TimesheetAutofillReceived.next();
          
        },
        error => {
          alert('error');
        }
      );

    }).catch((err) => {

    });
  }

  get_Grid1Data() {
    return this.Grid1Data;
  }
  
  get_Grid2Data() {
    return this.Grid2Data;
  }
}



// WEBPACK FOOTER //
// ./src/providers/requests/requests.ts